package com.milta.core.localization

/**
 * MIL-53 — Dashboard Web "Paramètres" screen. Reuses `common.navParametres` for the screen/nav
 * title (already translated, see [CommonStrings]) and `subscription.perMonth`/`noExpiry` for the
 * abonnement card — only genuinely new labels live here.
 */
data class SettingsStrings(
    // Carte "Profil de l'organisation" — nom en lecture seule, modification hors MVP.
    val profileSectionTitle: String,
    val profileNameLabel: String,

    // Carte "Langue de l'interface"
    val languageSectionTitle: String,
    val languageSearchPlaceholder: String,
    /** Contient un "%d" — nombre de langues restantes non visibles dans la liste initiale. */
    val languageMoreAvailable: String,
    /** "server_error" | "offline" */
    val languageErrorGeneric: String,

    // Carte "Abonnement" (lecture seule)
    val subscriptionSectionTitle: String,
    val subscriptionPlanLabel: String,
    val subscriptionBillingLabel: String,
    val subscriptionRenewalLabel: String,
    val subscriptionBillingMonthly: String,
    val subscriptionBillingAnnual: String,
    /** Distinct de `subscription.planOrganisation` ("Entreprise", déjà utilisé côté mobile) — libellé
     * marketing complet de la maquette Paramètres, ex. "Organisation (Patron + équipe)". */
    val subscriptionPlanOrganisationLabel: String,
    /** Suffixe de prix affiché après le montant, ex. "HTVA / mois". */
    val subscriptionPriceSuffix: String,
    val subscriptionUnavailable: String,

    // Zone critique — suppression définitive de l'Organisation
    val deleteSectionTitle: String,
    val deleteWarning: String,
    /** Paragraphe décrivant l'effet exact : tournées + preuves supprimées, Chauffeurs dissociés
     * (jamais supprimés) — ne jamais dire que les comptes Chauffeurs sont supprimés. */
    val deleteDescription: String,
    val deleteConfirmLabel: String,
    val deleteButton: String,
    val deleteFinalDialogTitle: String,
    val deleteFinalDialogMessage: String,
    /** "server_error" | "offline" */
    val deleteErrorGeneric: String,

    // Carte "Mentions légales" (2 liens vers WebLegalScreen)
    val legalSectionTitle: String,
    val legalTermsLabel: String,
    val legalPrivacyLabel: String,
)
